export const redirects: Record<string, string> = {
  '/event/uMjQkOQh': '/event/fv3ZjGU5',
  '/event/Peru-Salsa-All-Stars-Milano-Carroponte-27-07-2025':
    '/event/Peru-Salsa-All-Stars-Milano-Segrate-Parco-Idroscalo-27-07-2025',
}
